import LpService from '@/common/api/lp'
import {
  GET_LP_PAGE,
  GET_CLIENT_LP_PAGE
} from './actions'
import {
} from './mutations'

const state = {
}

const getters = {
}

const actions = {
  [GET_LP_PAGE] (context, { lpCode, code, params = {} }) {
    return new Promise((resolve, reject) => {
      LpService.getLp(lpCode, code, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_CLIENT_LP_PAGE] (context, { lpDir, lpCode, code, params = {} }) {
    return new Promise((resolve, reject) => {
      LpService.getClientLp(lpDir, lpCode, code, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
